import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAnnouncement } from 'types/interfaces';

interface IAnnouncementState {
  isInitialized: boolean;
  announcement?: IAnnouncement;
}

export const initialState: IAnnouncementState = {
  announcement: undefined,
  isInitialized: false
};
const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    setAnnouncement(state, action: PayloadAction<IAnnouncement | undefined>) {
      state = { ...state, announcement: action.payload, isInitialized: true };
      return state;
    }
  }
});

export const announcementActions = announcementSlice.actions;
export default announcementSlice.reducer;
